import { getRelateRecordUid } from '.';
import { int32, uint16, uint32, uint8 } from '../../utils';
import { SLOT } from '../dataSource';
import { SLOT_PRE_LENGTH, genId, genRecord, makeFillUpOfFour } from './utils';

export function genSlotData(
  slot: Ast,
  curDataAddress: number,
  recordList: any[]
): { originData: any; originRecord: any } {
  const type = SLOT;
  const {
    name,
    includeApps,
    type: slotType,
    appWidgetID,
    SlotGroupName
  } = slot.attrsMap;
  const { children } = slot;
  let onlyOneChild = false;
  if (slotType === 'condition')
    return genSlotConditionData(slot, curDataAddress, recordList);
  const refTable: string[] = [];
  const positionTable: any[] = [];
  // 去掉一个遍历，一次性直接遍历出来即可
  children.forEach((item: Ast) => {
    const { ref, x, y } = item.attrsMap;
    refTable.push(ref);
    // refTable = refTable.filter(Boolean);
    if (x && y) {
      positionTable.push({ x, y });
    }
  });

  const slotItemUidTable: Buffer[] = [];
  refTable.forEach((ref: string) => {
    const slotItemResourceUid = getRelateRecordUid(ref, recordList);
    slotItemResourceUid && slotItemUidTable.push(slotItemResourceUid);
  });
  if (refTable.length === 1 && positionTable.length < 1) {
    slotItemUidTable.push(uint32(0));
    onlyOneChild = true;
  }

  let slotLength = SLOT_PRE_LENGTH;
  if (appWidgetID) {
    slotLength += 8;
  } else {
    slotLength += slotItemUidTable.length * 4;
  }
  slotLength += positionTable.length * 4;

  const dataTable = Buffer.concat(slotItemUidTable);
  const slotPosTable: Buffer[] = [];
  positionTable.forEach((item: any) => {
    const xy = int32(Number(item.x) + (Number(item.y) << 10));
    slotPosTable.push(xy);
  });
  let slotGroupBuf = new Uint8Array(0);
  let isSlotGroup = false;
  if (SlotGroupName && SlotGroupName !== 'none') {
    isSlotGroup = true;
    const { fillUpstr: SlotGroupStr, fillUpLength: SlotGroupStrLength } =
      makeFillUpOfFour(SlotGroupName);
    slotGroupBuf = new Uint8Array(
      Buffer.concat([
        new Uint8Array(uint8(SlotGroupStrLength)),
        uint8(0), // reserved1
        uint16(0), // reserved
        new Uint8Array(Buffer.from(SlotGroupStr))
      ])
    );
    slotLength += slotGroupBuf.length;
  }

  const originData = {
    type,
    slotType,
    name,
    includeApps,
    slotItemUidTable,
    slotItemUidData: dataTable,
    totalLength: slotLength,
    appWidgetID,
    slotPosTable,
    onlyOneChild,
    isSlotGroup,
    slotGroupBuf
  };
  const uid = genId(type);
  const originRecord = genRecord(
    type,
    name,
    uid,
    curDataAddress,
    originData.totalLength || 0
  );
  return { originData, originRecord };
}

/**
 * @description 专门用于创建Condition的Slot的数据的函数
 * @param slot Ast // 当前节点树
 * @param curDataAddress number 当前地址
 * @param recordList record[] 记录列表
 * @returns
 */
const genSlotConditionData = (
  slot: Ast,
  curDataAddress: number,
  recordList: any[]
) => {
  const type = SLOT;
  const { attrsMap, children } = slot;
  const { type: slotType, name } = attrsMap;

  const pos_tables: any[] = [];
  // condition_widgets
  const condition_widgets = children.map((item) => {
    const { ref, x, y, condition, selectMethod } = item.attrsMap;

    // 先处理位置信息
    if (x && y) {
      const xy = int32(Number(x) + (Number(y) << 10));
      pos_tables.push(xy);
    }

    // 生成 condition 的 Id
    const uid_condition: Buffer = condition
      ? (getRelateRecordUid(condition, recordList) as Buffer)
      : uint32(0);

    // 生成 widgets 的 Id
    const refs = ref
      .split(' ')
      .map((item) => item.trim())
      .filter((ref) => !!ref);

    const uid_widgets: Buffer[] = refs.map((ref) =>
      getRelateRecordUid(ref, recordList)
    ) as Buffer[];

    const widget_cnt = uid_widgets.length;

    // 统计当前slot涉及到的所有widget数量
    const pre_length = 4 + 2 + 2;

    return {
      uid_condition,
      widget_cnt,
      select_method: getSelectMethod(selectMethod),
      uid_widgets,
      totalLength: pre_length + uid_widgets.length * 4
    };
  });
  // 总长度 = condition_widgets的长度和 + posTable数量 * 4
  const totalLength =
    SLOT_PRE_LENGTH +
    condition_widgets.reduce((prev, current) => prev + current.totalLength, 0) +
    pos_tables.length * 4;

  // 数据
  const originData = {
    type,
    slotType,
    name,
    totalLength,

    widgets_count: children.length,
    reserved: 0,
    flags: 4,
    condition_widgets,
    pos_tables
  };

  // 记录
  const uid = genId(type);
  const originRecord = genRecord(
    type,
    name,
    uid,
    curDataAddress,
    originData.totalLength || 0
  );
  return { originData, originRecord };
};

const getSelectMethod = (select_method: string) => {
  if (select_method === 'inOrder') return 0;
  return 0;
};
